/** Otevírání vygenerovaných PDF bez blokování vyskakovacích oken.

    Prohlížeče (hlavně Safari na Macu a iPhonu) povolí `window.open` jen
    přímo v reakci na klik. PDF se ale generuje několik sekund a otevřít ho
    až potom = zablokované okno. Proto:
      1. při kliknutí hned otevřeme prázdnou záložku „Připravuji PDF…“,
      2. až je PDF hotové, pošleme ji na jeho adresu,
      3. když prohlížeč i tak záložku nepovolil, vrátí se `false` a stránka
         ukáže kartu s odkazem „Otevřít PDF“ (klik na odkaz blokovaný není). */

export function pripravOkno() {
  let okno = null;
  try {
    okno = window.open("", "_blank");
  } catch {
    okno = null;
  }
  if (okno) {
    try {
      okno.document.title = "Připravuji PDF…";
      okno.document.body.innerHTML =
        '<p style="font-family:system-ui,sans-serif;padding:32px;color:#5b5f66">Připravuji PDF…</p>';
    } catch {
      /* jiný původ — nevadí, jen bez textu */
    }
  }
  return okno;
}

/** Pošle připravenou záložku na hotové PDF. `false` = záložka není (blokováno / zavřena). */
export function otevritPdf(okno, url) {
  if (okno && !okno.closed) {
    try {
      okno.opener = null; // PDF nemá mít přístup zpět do aplikace
      okno.location.href = url;
      return true;
    } catch {
      return false;
    }
  }
  return false;
}

/** Při chybě generování prázdnou záložku zase zavřít. */
export function zavritOkno(okno) {
  try {
    if (okno && !okno.closed) okno.close();
  } catch {
    /* nic */
  }
}

/** Do čekající záložky napíše, proč to trvá (po aktualizaci aplikace). */
export function textOkna(okno, text) {
  try {
    if (okno && !okno.closed) {
      okno.document.body.innerHTML =
        `<p style="font-family:system-ui,sans-serif;padding:32px;color:#5b5f66;max-width:520px;line-height:1.5">${text}</p>`;
    }
  } catch {
    /* jiný původ — nevadí */
  }
}

export const TEXT_PRIPRAVA = "Připravuji PDF… Aplikace se po aktualizaci připravuje, první PDF může trvat až 3 minuty. Záložku nezavírej, PDF se tu otevře samo.";

/** Má se ukázat hláška o čekání? Server ví, že se tisk zprovozňuje, nebo to trvá déle než 12 s. */
export const dlouhoCeka = (odpoved, zacatek) => !!odpoved?.pripravuje_prohlizec || Date.now() - zacatek > 12000;
